/* unplugin-vue-components disabled */import script from "./auto-setting.vue?vue&type=script&setup=true&lang=js"
export * from "./auto-setting.vue?vue&type=script&setup=true&lang=js"

import "./auto-setting.vue?vue&type=style&index=0&id=03e0d8e8&lang=scss"

const __exports__ = script;

export default __exports__